import { ActionTypes } from './constants';

export const deletingPreviewProvider = () => ({
    type: ActionTypes.DELETING_PREVIEW_PROVIDER,
});

export const deletePreviewProviderSuccess = () => ({
    type: ActionTypes.DELETE_PREVIEW_PROVIDER_SUCCESS,
});

export const deletePreviewProviderFailure = () => ({
    type: ActionTypes.DELETE_PREVIEW_PROVIDER_FAILURE,
});

const apiHost = process.env.API_HOST || '';
const deletePreviewProviderEndpoint = (previewProviderId, dataSource) => `${apiHost}/api/web/2/previewprovider/${previewProviderId}/${dataSource}`;

export function deletePreviewProvider(previewProviderId, dataSource) {
    return dispatch => {
        dispatch(deletingPreviewProvider());
        return fetch(deletePreviewProviderEndpoint(previewProviderId, dataSource), {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
            },
            credentials: 'include',
        })
            .then(response => {
                if (response.status === 200) {
                    dispatch(deletePreviewProviderSuccess());
                } else {
                    dispatch(deletePreviewProviderFailure());
                }
            })
            .catch(() => {
                dispatch(deletePreviewProviderFailure());
            });
    };
}
